import {createContext} from 'react';

const ErrorContext=createContext();

export default ErrorContext;